<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Pin Off" class="d-icon d-icon--pin-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"><path d="M3.446 1a.5.5 0 0 1 .5-.5H8a1.5 1.5 0 0 1 0 3v1.17a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5H8a.5.5 0 0 0 0-1H3.946a.5.5 0 0 1-.5-.5ZM.647.647a.5.5 0 0 1 .707 0l10 10a.5.5 0 1 1-.707.707L8.293 9H6.5v2a.5.5 0 1 1-1 0V9h-3a.5.5 0 0 1-.5-.5v-.88a1.5 1.5 0 0 1 .831-1.342l.892-.45A.5.5 0 0 0 4 5.38v-.673L.647 1.354a.5.5 0 0 1 0-.707Zm3.522 6.075a1.5 1.5 0 0 0 .801-1.045L7.293 8H3v-.38a.5.5 0 0 1 .278-.447l.891-.451Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPinOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
